module.exports = __webpack_public_path__ + "5353fccc2311cbec099d4de423b78bb3.svg";